// Astrea Ops Platform - Unavailability data-access layer (per-person leave/blocked dates)
//
// Phase 3, third slice, following the Database and users/auth slices in
// claude/go-live-plan.md. The app's existing `unavailability` array shape
// (id, userId, start, end, reason) stays exactly as every tab already consumes
// it - only the load/save boundary changes, from the old localStorage blob to
// real per-row Supabase reads and writes against the `unavailability` table
// from supabase/migrations/20260915000003_projects_and_lifecycle.sql
// (person_id, start_date, end_date, reason).
//
// unavailability sits behind the same is_internal_staff() RLS bucket as every
// other real table (see supabase/migrations/20260915000007_rls_policies.sql),
// so - learned the hard way on the users/auth slice, see go-live-plan.md's
// "A real login bug" section - loadUnavailability() must only ever be called
// with an authenticated session, never on mount before sign-in. App.jsx's
// loading effect for `unavailability` is scoped to currentUser?.id from the
// start on this slice, the same fix already applied to `users`/`database`.
//
// Ids: same convention as database.js and people.js - a new entry gets a real
// UUID assigned client-side with crypto.randomUUID() (App.jsx's own uid() is a
// short Math.random() string, not a valid Postgres uuid) rather than waiting
// on Supabase's own gen_random_uuid() default.

import { supabase } from './supabaseClient';
import { selectAllRes } from './selectAll';

function rowToEntry(row) {
  return {
    id: row.id,
    userId: row.person_id,
    start: row.start_date,
    end: row.end_date,
    reason: row.reason || '',
  };
}

export async function loadUnavailability() {
  const { data, error } = await selectAllRes(() => supabase.from('unavailability').select('*').order('id'));
  if (error) throw error;
  return (data || []).map(rowToEntry);
}

// entry must already carry a real UUID id (see the module note above).
export async function unavailabilityCreate(entry) {
  const { error } = await supabase.from('unavailability').insert({
    id: entry.id,
    person_id: entry.userId,
    start_date: entry.start,
    end_date: entry.end,
    reason: entry.reason || null,
  });
  if (error) throw error;
}

export async function unavailabilityDelete(id) {
  const { error } = await supabase.from('unavailability').delete().eq('id', id);
  if (error) throw error;
}
